export const constants = {
  SHOW_CONFIRMATION: 'SHOW_CONFIRMATION',
  BUTTON_CONFIRMATION: 'BUTTON_CONFIRMATION',
  LOCATION_CONFIRMATION: 'LOCATION_CONFIRMATION',
  ID_CONFIRMATION: 'ID_CONFIRMATION',
};
